import { Component } from "react";
import { CredentialProps } from "../CredentialProps";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";

interface HostBasicAuthListPageProps extends NSARouterMakerResult, CredentialProps { }

export default class HostBasicAuthListPage extends Component<HostBasicAuthListPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section lists all the Host Basic Auth credentials saved in your workspace, showing each one's name and identifiers. You can open, copy, edit, or delete any entry, review its change history, or create a new one.",
                }}
                pages={{
                    entity: CredentialEntities.host_basic_auth(this.props),
                    list: {}
                }}
            >
                <></>
            </CredentialLayout >
        );
    }
}